import { connect } from 'react-redux';
import { toggleNavigationMenu } from 'common/navigation/containers/navigation-actions';
import { setMenuVisible } from './header-actions';
import Header from '../components/header';

const mapStateToProps = state => ({
  expand: state.navigation.expand,
  menuVisible: state.header.menuVisible,
});

const mapDispatchToProps = {
  toggleNavigationMenu,
  setMenuVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
